import PageLayout from './PageLayout.jsx';
import PageLayout6 from './PageLayout6.jsx';

export default PageLayout;
export { PageLayout6 };